module.exports = __webpack_public_path__ + "static/media/home_private.0feef48a.png";